/**
 * A duration token (`--motion-*`, or a surface's own such as `--shell-flyout-out`) in milliseconds, read when called.
 *
 * For a script that has to wait out a CSS transition — a panel kept mounted through its exit, a
 * morph that holds the DOM still while it runs — so the wait and the transition read one number
 * instead of two that can drift. `fallback` when the token cannot be read, as in a test's jsdom,
 * which loads no stylesheet.
 */
export function motionDuration(token: `--${string}`, fallback: number): number {
  const raw = getComputedStyle(document.documentElement).getPropertyValue(token).trim()
  const match = /^(\d*\.?\d+)(ms|s)$/.exec(raw)
  if (match === null) return fallback
  const amount = Number(match[1])
  return match[2] === 's' ? amount * 1000 : amount
}
